

































































































import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { GroupData } from "@/models/business-rules/GroupData";
import { RulesConditions } from "@/models/business-rules/RulesConditions";
import { RulesSetData } from "@/models/business-rules/RulesSetData";
import CreateGroupAndRule from "@/views/business-rules/components/CreateGroupAndRule.vue";
import RuleConditions from "@/views/business-rules/components/RuleConditions.vue";
import RuleConditionsOutcome from "@/views/business-rules/components/RuleConditionsOutcome.vue";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "RulesEngine",
  components: { CreateGroupAndRule, RuleConditions, RuleConditionsOutcome }
})

export default class RulesEngine extends Vue {
  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("createNewCondition") public createNewCondition!: () => void;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;
  @businessRules.Action("handleRuleName") public handleRuleName!: (ruleName: string) => void;
  @businessRules.Action("handleRuleDays") public handleRuleDays!: (ruleDays: number |
  null) => void;
  @businessRules.Action("removeSelectedCondition") public removeSelectedCondition!: (condition: number | string) => void;

  // ===== Data ===== //
  public editing = false;

  // ===== Methods ===== //
  public async cancelCondition(condition: number | string): Promise<void> {
    await this.removeSelectedCondition(condition);
  }
  public handleEditRuleName(): void {
    this.editing = !this.editing;
  }
  public handleCreateNewCondition(): void {
    const conditionValues = this.ruleConditions.every(condition => condition.value !== null);
    if (conditionValues) {
      this.createNewCondition();
    }
  }

  // ===== Computed ===== //
  get conditionsValid(): boolean {
    return !!(this.ruleConditions &&
      this.ruleConditions.length &&
      this.ruleConditions[0].metric &&
      this.ruleConditions[0].comparison &&
      this.ruleConditions[0].value !== null
    );
  }
  get currentStep(): number {
    return this.businessRules.currentStep;
  }
  get ruleConditions(): RulesConditions[] {
    return this.businessRules.currentSelectedConditions;
  }
  get ruleName(): string {
    return this.selectedRuleSet ? this.selectedRuleSet.name : this.businessRules.ruleName;
  }
  set ruleName(newVal: string) {
    this.handleRuleName(newVal);
  }
  get ruleDays(): number|null {
    return this.selectedRuleSet ? this.selectedRuleSet.number_days : this.businessRules.number_days;
  }
  set ruleDays(newVal: number|null) {
    this.handleRuleDays(newVal);
  }
  get sameRuleName(): boolean {
    return this.selectedRuleSet
      ? this.businessRules.ruleName === this.selectedRuleSet.name
      : false;
  }
  get selectedGroup(): GroupData {
    return this.businessRules.selectedGroup!;
  }
  get selectedRuleSet(): RulesSetData {
    return this.businessRules.selectedRuleSet!;
  }
}

